import React from 'react';
import { Modal } from 'antd';
import { MESSAGES } from '@translations/labels';
import { styleToHideButtonInModal } from '@common-components/modal/modal-tools';
import { Provider } from 'react-redux';
import store from '@store';
import { SaveVersionModalContent } from '../../common/save-version-modal/saveVersionModalContent';

const labels = { ...MESSAGES.manageBot };
const commonLabels = { ...MESSAGES.commons };

export const openSaveVdnVersionModal = (onCreateVersion) => {
  const handleOk = () => {
    return (okResult) => {
      Modal.destroyAll();
      const { versionName, versionDescription } = okResult;
      onCreateVersion(versionName, versionDescription);
    };
  };

  const handleCancel = () => {
    Modal.destroyAll();
  };

  const modalSettings = {
    width: 563,
    icon: false,
    okButtonProps: styleToHideButtonInModal(),
  };

  const contentSettings = {
    resourceType: 'VDN map',
    okText: (labels.saveVersionModal && labels.saveVersionModal.createVersion
      ? labels.saveVersionModal.createVersion
      : 'CREATE VERSION'
    ).toUpperCase(),
    cancelText: (commonLabels.cancel || 'CANCEL').toLocaleUpperCase(),
    onOk: handleOk(),
    onCancel: handleCancel,
  };

  Modal.info({
    ...modalSettings,
    content: (
      <Provider store={store}>
        <SaveVersionModalContent settings={contentSettings} />
      </Provider>
    ),
  });
};
